import React from "react";
import styled from "styled-components";
import { Spinner, Markdown } from "components/common";
import { Alert } from "components/bootstrap";
import useWorkflowPrompt from "aiagent/AgentWorkflows/hooks/useWorkflowPrompt";
const PromptContent = styled.div`
  overflow-wrap: anywhere;

  pre {
    white-space: pre-wrap;
  }
`;
const WorkflowPrompt = ({ workflowId }) => {
  const { data: prompt, isLoading, isError, error } = useWorkflowPrompt(workflowId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isLoading && /* @__PURE__ */ React.createElement(Spinner, { text: "Loading prompt..." }), isError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Failed to load prompt" }, error instanceof Error ? error.message : "Unknown error"), !isLoading && !isError && /* @__PURE__ */ React.createElement(PromptContent, null, prompt ? /* @__PURE__ */ React.createElement(Markdown, { text: prompt }) : "No prompt available"));
};
export default WorkflowPrompt;
